import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Results from '../views/Results.vue'
import AdvSearch from '../views/AdvSearch.vue'
import Dataset from '../views/Dataset.vue'
import Collection from '../views/Collection.vue'
import Dataview from '../views/Dataview.vue'
import NotFound from '../views/404.vue'
import Visualization from '../visualizations/View.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    alias: '/home',
    name: 'index',
    component: Index
  },
  {
    path: '/results',
    name: 'results',
    component: Results
  },
  {
    path: '/advsearch',
    name: 'advsearch',
    component: AdvSearch
  },
  {
    path: '/dataset/:id',
    name: 'dataset',
    component: Dataset
  },
  {
    path: '/collection/:id',
    name: 'collection',
    component: Collection
  },
  {
    path: '/view/:datasetId/:dataviewId?',
    name: 'dataview',
    component: Dataview
  },
  {
    path: '/visualization/:component',
    name: 'visualization',
    component: Visualization
  },
  {
    path: '/profile',
    redirect: { name: 'results', query: { term: 'profile' }}
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
